module.exports = __webpack_public_path__ + "img/2.245a020c.jpg";